import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ChatService} from '../../services/chat.service';
import {Subscription} from 'rxjs';
import {ChatMessage} from 'src/app/models/chats/chatMessageListResponse';
import {MsalService} from '@azure/msal-angular';
import {NgxSpinnerService} from "ngx-spinner";
import { SweetAlertService } from '../../services/sweet-alert.service';

@Component({
  selector: 'app-chat-channel',
  templateUrl: './chat-channel.component.html',
  styleUrls: ['./chat-channel.component.scss'],
  providers: [
    ChatService,
    { provide: 'GrantApplicationId', useValue: 'your-dynamic-id' }
  ]
  // providers: [
  //   {
  //     provide: ChatService,
  //     useFactory: (msalService: MsalService, http: HttpClient, grantApplicationId: string) =>
  //       new ChatService(msalService, http, grantApplicationId),
  //     // useFactory: (grantApplicationId : string) => new ChatService(grantApplicationId), // Inject the specific id here
  //     deps: [[MsalService, HttpClient, new String()]],
  //   },

  // ],
})
export class ChatChannelComponent implements OnInit, OnDestroy {
  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;
  focus: any;
  newMessage: string = '';
  latest : string ='';
  private username: string = '';
  messages: ChatMessage[] = [];
  moreLoad : boolean = true;
  private messagesSub?: Subscription;
  private moreLoadSub?: Subscription;
  @Input() grantApplicationId: string = '';
  isDeleting: boolean = false;

  constructor(
    private chatService: ChatService,
    private msalService: MsalService,
    private spinner: NgxSpinnerService,
    private sweetAlertService: SweetAlertService
  ) {}

  async ngOnInit() {
    this.chatService.setGrantApplicationId(this.grantApplicationId);
    this.moreLoadSub = this.chatService.moreLoad$.subscribe((moreLoadChat: boolean) => {this.moreLoad = moreLoadChat});
    this.messagesSub = this.chatService.messages$.subscribe((chatMessages: ChatMessage[]) => {
      this.messages = chatMessages.map((msg) => ({
        text: msg.text,
        time: msg.time,
        sender: msg.user === this.username ? 'You' : msg.user,
        id: msg.id
      }));
    });

    let activeAccount = this.msalService.instance.getActiveAccount();

    if (activeAccount != null && this.msalService.instance.getAllAccounts().length > 0) {
        this.username = activeAccount.username;
    }

    const resLatest = await this.chatService.fetchMessages(new Date().toISOString());
    this.latest = resLatest;


    setTimeout(() =>{
      this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
    },500);


    this.chatService.startConnection(() => {
      this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
    }).then(() => {
      console.log('Connection started successfully!');
    })
    .catch((error) => {
      console.error('Error initializing SignalR connection:', error);
    });



    document.getElementsByTagName('body')[0].classList.add('chat-page');
  }

  ngOnDestroy() {
    if (this.messagesSub) {
      this.messagesSub.unsubscribe();
    }

    document.getElementsByTagName('body')[0].classList.remove('chat-page');
  }

  sendMessage() {
    if (this.newMessage.trim()) {
      this.chatService.sendMessage(this.newMessage);
      this.newMessage = '';
    }
  }

  public async fetchMessage(){
    const resLatest = await this.chatService.fetchMessages(new Date(this.latest).toISOString());

    this.latest = resLatest;
  }
  /**
   * Renders a message timestamp. Public because the template calls it.
   *
   * Never returns the literal string "Invalid Date": an unparseable Date makes
   * toLocaleString() return that text, which used to leak straight into the DOM.
   */
  public convertToLocalDateTime(dateStr: string | undefined): string {
    const date = dateStr ? new Date(dateStr) : null;

    if (!date || isNaN(date.getTime())) {
      console.warn('ChatChannel: unrenderable message timestamp', dateStr);
      return '—';
    }

    // No `timeZone` option on purpose: chat is two-way, so each side sees its own local time.
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');
  }

  openDeleteConfirmation(messageId: string | undefined) {
    if (!messageId) {
      console.error('Cannot delete message: Message ID is undefined');
      return;
    }

    this.sweetAlertService.fire({
      icon: 'warning',
      title: 'Confirm Delete',
      text: 'Are you sure you want to delete this message? This action cannot be undone.',
      showCancelButton: true,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteMessage(messageId);
      }
    });
  }

  async deleteMessage(messageId: string | undefined) {
    if (!messageId) {
      console.error('Cannot delete message: Message ID is undefined');
      return;
    }

    if (this.isDeleting) {
      return; // Prevent multiple delete requests
    }

    this.isDeleting = true;
    await this.spinner.show(); // Show loading spinner

    try {
      await this.chatService.deleteMessage(messageId);
      // The service already updates the messages list via the BehaviorSubject
    } catch (error) {
      console.error('Error deleting message:', error);
    } finally {
      this.isDeleting = false;
      await this.spinner.hide(); // Hide loading spinner
    }
  }
}
